import MySpinner from "./spinner";
export default MySpinner;